import { Avatar } from "@mui/material";
import React, { useEffect } from "react";
import { ImageCroppingPresets } from "../../../modules/Media/MediaUtils";
import { IconPerson } from "../../Icons";
import { useAssetMedia } from "../Assets/AssetCard";
export const PersonAvatar = ({ person }) => {

    const { assetPath, setAssetId } = useAssetMedia({ args: ImageCroppingPresets.preview });

    useEffect(() => {
        if (!person?.coverPhotoId) return;
        setAssetId(person.coverPhotoId)
    }, [person?.coverPhotoId])

    return (
        <Avatar src={assetPath} sx={{ bgcolor: '#EBB902' }}>
            <IconPerson />
        </Avatar>
    )
}